import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const colorChange = keyframes`
  0%, 100% {
    background: #5682a5;
  }
  50% {
    background: #cfcfdf;
  }
`;

const Dot = styled.div`
  width: 17px;
  height: 17px;
  margin: 5px;
  border-radius: 50%;
  display: inline-block;
  animation: ${colorChange} 1.4s infinite ease-in-out both;

  &:nth-of-type(1) {
    animation-delay: -0.32s;
  }

  &:nth-of-type(2) {
    animation-delay: -0.16s;
  }
`;

const LoadingDots = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '70px',
        marginTop: '7px',
        marginRight: '5px',
      }}
    >
      <Dot />
      <Dot />
      <Dot />
    </div>
  );
};

export default LoadingDots;
